import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar resultado',
  message = 'Você tem certeza? A próxima partida será montada automaticamente.',
  confirmLabel = 'Confirmar',
}) => (
  <Dialog open={Boolean(isOpen)} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} color="inherit">Cancelar</Button>
      <Button onClick={onConfirm} variant="contained">{confirmLabel}</Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
